// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/body/itemPage.styl
// module id = 246
// module chunks = 0